<script lang="ts">
	import {
		emeterPriorityDevForce,
		emeterPriorityDevHudFamily,
		setEmeterPriorityDevForce,
	} from 'src/stores/features/dev/emeter-priority-dev-state';
	import PriorityLayoutDevHud from 'src/components/Sidepanel/PriorityLayoutDevHud.svelte';
	import {
		emeterPriorityDevOptionsFor,
		type EmeterPriorityDevForce,
	} from 'src/helpers/emeter_priority_layout';

	$: hudOptions = emeterPriorityDevOptionsFor($emeterPriorityDevHudFamily === 'single');

	const onSelect = (id: string) => {
		setEmeterPriorityDevForce(id as EmeterPriorityDevForce);
	};
</script>

<PriorityLayoutDevHud
	options={hudOptions}
	selectedId={$emeterPriorityDevForce}
	idPrefix="emeter-priority-dev"
	{onSelect}
/>
